import React from 'react'
import logoImg from '../../assets/images/logo.png'
import './logo.css';

function AppLogo() {
    return (
        <div className="logo-container">
            <img src={logoImg} alt="Abra" />
        </div>
    )
}

export default AppLogo
